import React,{useEffect} from "react";
import Card from 'react-bootstrap/Card'
import {Row} from 'react-bootstrap'
import "./ReadMore.css"

import user from "../../img/user.svg";
import date from "../../img/date.svg";
import moment from 'moment'



function ReadMore(props){
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className='justify-content-center' style={{paddingLeft:"15rem",paddingRight:'15rem',margin:'2rem'}}> 
            
           
            <Card style={{borderColor:"white"}}>
            
    <Card.Img src={props.location.state.blog.imageUrl} style={{width:"100%"}}></Card.Img>
    <Row style={{marginLeft:"2px"}}>
    
    <img src={user} alt="user" style={{margin:"0.2rem"}}/>
    <p style={{paddingTop:"1rem", color:"gray",marginRight:'2rem'}}>{props.location.state.blog.authorName}</p>
    <img src={date} alt="date" style={{margin:"0.2rem"}}/>
    
    <p style={{paddingTop:"1rem",color:"gray"}}>{moment.unix(props.location.state.blog.date).format(" MMM, DD YYYY")}</p>

    <p style={{paddingBottom:"2rem",lineHeight:'1.7rem',display: 'block',fontSize:'1.3rem'}}>
    <h1 style={{paddingTop:"1rem",fontWeight:'bolder',textTransform: 'capitalize'}}>{props.location.state.blog.title.toString()}</h1><br/>
    
    
    
    <div dangerouslySetInnerHTML={{ __html: props.location.state.blog.desc.replace(/\r\n|\n|\r/g, "<br/> <br/>") }} />
    
   
    </p>
    </Row>
    

            </Card>
          

           
        </div>

    );
}
 


export default ReadMore;